import { TextField } from '@material-ui/core';
import { IQuestionProps } from 'pages/forms/hooks/useAnswerManager/types';
import React, { useEffect, useState } from 'react';

export const NumericQuestion = ({ handleChangeAnswer, question, disableInput }: IQuestionProps) => {
  const [inputValue, setInputValue] = useState<string>('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setInputValue(value);
    handleChangeAnswer(question.id, { text: value });
  };

  const avoidChars = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const excludeChars = ['e', '-', '+'];

    if (excludeChars.includes(event.key.toLowerCase())) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (question.answer) {
      const savedAnswer = question.answer.text;
      setInputValue(savedAnswer);
      handleChangeAnswer(question.id, { text: savedAnswer });
    }
  }, [question]);

  return (
    <TextField
      variant="standard"
      label="Escreva a sua resposta"
      fullWidth
      onChange={handleChange}
      onKeyDown={avoidChars}
      value={inputValue}
      type="number"
      disabled={disableInput}
    />
  );
};
